import { GROUPS_TO_SHOW } from './customer-groups-view-config';
export var getCustomerGroupsToShow = function (allCustomerGroups, groupsToShow) {
    if (groupsToShow === void 0) { groupsToShow = GROUPS_TO_SHOW; }
    if (!allCustomerGroups) {
        return [];
    }
    return groupsToShow
        .map(function (groupName) {
        return allCustomerGroups.find(function (group) { return group.name === groupName; });
    })
        .filter(function (group) { return (group === null || group === void 0 ? void 0 : group.customers) > 0; });
};
